<div *ngIf="isMobile; else webLogin">
  <div class="mobile-header">
    <img
      *ngIf="utilityLogo"
      class="utility-logo"
      [src]="utilityLogo"
      alt="utility-logo-mobile"
    >
    <div class="mobile-title">
      {{title}}
    </div>
    <img
      *ngIf="utilityLogo"
      class="utility-logo-right"
      [src]="utilityLogo"
      alt="utility-logo-right"
    >
  </div>
</div>

<ng-template #webLogin>

</ng-template>
